(function () {
  var MAX_FILE_SIZE = 10 * 1024 * 1024;
  var UNIT_PRICE = 25;
  var MAX_QTY = 20;

  function formatSize(bytes) {
    return (bytes / (1024 * 1024)).toFixed(1) + 'MB';
  }

  function init() {
    var section  = document.getElementById('CartDrawer-LogoSection');
    if (!section) return;

    var checkbox   = document.getElementById('CartDrawerLogoCheckbox');
    var form       = document.getElementById('CartDrawerLogoForm');
    var fileInput  = document.getElementById('CartDrawerLogoFile');
    var contact    = document.getElementById('CartDrawerLogoContact');
    var submitBtn  = document.getElementById('CartDrawerLogoSubmit');
    var status     = document.getElementById('CartDrawerLogoStatus');
    var qtyInput   = document.getElementById('CartDrawerLogoQty');
    var qtyDisplay = document.getElementById('CartDrawerLogoQtyDisplay');
    var qtyMinus   = document.getElementById('CartDrawerLogoQtyMinus');
    var qtyPlus    = document.getElementById('CartDrawerLogoQtyPlus');
    var priceLabel = document.getElementById('CartDrawerLogoPrice');

    if (!checkbox || !form) return;

    function qty() { return parseInt(qtyInput.value, 10) || 1; }

    function setQty(n) {
      qtyInput.value = n;
      qtyDisplay.textContent = n;
      if (priceLabel) priceLabel.textContent = '$' + (UNIT_PRICE * n);
    }

    // Toggle expand — the section animates via max-height CSS
    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        section.classList.add('nor-logo-open');
        form.style.display = 'flex';
      } else {
        section.classList.remove('nor-logo-open');
        form.style.display = 'none';
        status.textContent = '';
      }
    });

    qtyMinus && qtyMinus.addEventListener('click', function (e) {
      e.preventDefault();
      if (qty() > 1) setQty(qty() - 1);
    });
    qtyPlus && qtyPlus.addEventListener('click', function (e) {
      e.preventDefault();
      if (qty() < MAX_QTY) setQty(qty() + 1);
    });

    fileInput.addEventListener('change', function () {
      status.textContent = '';
      if (fileInput.files.length && fileInput.files[0].size > MAX_FILE_SIZE) {
        status.textContent = 'File is ' + formatSize(fileInput.files[0].size) + ' — please upload something under 10MB.';
        fileInput.value = '';
      }
    });

    form.addEventListener('submit', function (e) {
      status.textContent = '';
      if (!fileInput.files.length) {
        e.preventDefault();
        status.textContent = 'Please choose a logo file.';
        return;
      }
      if (fileInput.files[0].size > MAX_FILE_SIZE) {
        e.preventDefault();
        status.textContent = 'File is ' + formatSize(fileInput.files[0].size) + ' — please upload something under 10MB.';
        return;
      }
      if (!contact.value.trim()) {
        e.preventDefault();
        status.textContent = 'Please add your email or Instagram handle.';
        return;
      }
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
